import React from "react";
import { Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import MailIcon from '@mui/icons-material/Mail';
import GitHubIcon from '@mui/icons-material/GitHub';
import { LinkedIn } from "@mui/icons-material";
import DescriptionIcon from '@mui/icons-material/Description';

const contactOptions = [
  {
    name: "Email",
    value: "amari.lawal05@gmail.com",
    link: "mailto:amari.lawal05@gmail.com",
    Icon: MailIcon
  },
  {
    name: "Github",
    value: "amarilawal",
    link: "https://github.com/CaesarCloudSync",
    Icon: GitHubIcon
  },
  {
    name: "Linkedin",
    value: "amarilinkedin",
    link: "https://linkedin.com/in/amari-lawal49823a1b4",
    Icon: LinkedIn
  },
  {
    name: "CV",
    value: "AmariCV",
    link: "/Amari_Hussey_CV.pdf",
    Icon: DescriptionIcon
  }
];

function ContactMe() {
  return (
    <div className="portfolio-section-dark">
      <h2 id="contactme" className="portfolio-section-title">
        Contact <span style={{ color: "var(--color-accent)" }}>Me</span>
      </h2>
      <div className="contact-container">
        <div className="contact-cards-container">
          {contactOptions.map(({ name, value, link, Icon }) => (
            <Card bg="white" className="contact-card" key={name}>
              <div className="contact-icon-wrapper">
                <a href={link} target="_blank" rel="noreferrer" style={{ display: "inline-flex" }}>
                  <Icon className="contact-icon" />
                </a>
              </div>
              <Card.Body className="p-0 d-flex flex-column align-items-center">
                <Card.Title className="contact-card-title">{name}</Card.Title>
                <Card.Text className="m-0">
                  <a href={link} target="_blank" rel="noreferrer" className="contact-card-link">
                    {value}
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContactMe;